import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export const inputGroupAddonVariants = cva(
    "text-muted-foreground flex h-full cursor-text items-center justify-center gap-2 text-base font-normal select-none [&>.sph-icon]:size-4.5! [&>kbd]:rounded-[calc(var(--radius)-5px)] group-data-[disabled=true]/input-group:opacity-50 group-data-[disabled=true]/input-group:cursor-not-allowed group-data-[disabled=true]/input-group:bg-input-disabled",
    {
        variants: {
            align: {
                "inline-start":
                    "order-first pl-3 has-[>button]:ml-[-0.45rem] has-[>kbd]:ml-[-0.35rem]",
                "inline-end":
                    "order-last pr-3 has-[>button]:pr-0 has-[>kbd]:mr-[-0.35rem]",
                "block-start":
                    "order-first w-full justify-start px-3 pt-3 [.border-b]:pb-3 group-has-[>input]/input-group:pt-2.5",
                "block-end":
                    "order-last w-full justify-start px-3 pb-3 [.border-t]:pt-3 group-has-[>input]/input-group:pb-2.5",
            },
        },
        defaultVariants: {
            align: "inline-start",
        },
    },
)

export type InputGroupVariants = VariantProps<typeof inputGroupAddonVariants>

export const inputGroupButtonVariants = cva(
    "text-sm shadow-none flex gap-2 items-center",
    {
        variants: {
            size: {
                "xs": "h-6 gap-1 px-2 rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-3.5 has-[>svg]:px-2",
                "sm": "h-8 px-2.5 gap-1.5 rounded-md has-[>svg]:px-2.5",
                "icon-xs": "size-6 rounded-[calc(var(--radius)-5px)] p-0 has-[>svg]:p-0",
                "icon-sm": "size-8 p-0 has-[>svg]:p-0",
            },
        },
        defaultVariants: {
            size: "xs",
        },
    },
)

export type InputGroupButtonVariants = VariantProps<typeof inputGroupButtonVariants>
